import Device from '../../common/device';
import { ApiError } from '../../types/errors';
import Constants from '../../utils/constants';
import { AccountResponse, FaqItemType, LoginResponse } from '../models/account';
import sendRequest, { getSession } from '../response';

export async function login(
  login: string,
  password: string,
  softId: string,
  uuid: string,
): Promise<LoginResponse> {
  const data = new FormData();
  data.append('login', login);
  data.append('pass', password);
  data.append('softid', softId);
  data.append('cli_serial', uuid);

  const res = await sendRequest(
    `${Constants.apiBaseUrl}/login?settings=all`,
    { ...Device.getDeviceHeaders() },
    data,
  );
  if (!(res instanceof Object)) throw new ApiError(-2, 'Wrong response');
  if ('error' in res) throw new ApiError(res.error.code, res.error.message);

  return res;
}

export async function account(): Promise<AccountResponse> {
  const [sn, s] = getSession();
  const res = await sendRequest(
    `${Constants.apiBaseUrl}/account?settings=all&${sn}=${s}`,
    { ...Device.getDeviceHeaders() },
  );
  if (!(res instanceof Object)) throw new ApiError(-2, 'Wrong response');
  if ('error' in res) throw new ApiError(res.error.code, res.error.message);

  return res;
}

export async function setStandart(standart: string) {
  const [sn, s] = getSession();
  const res = await sendRequest(
    `${Constants.apiBaseUrl}/settings_set?${sn}=${s}&var=stream_standard&` +
      `val=${standart}`,
    { ...Device.getDeviceHeaders() },
  );
  if (!(res instanceof Object)) throw new ApiError(-2, 'Wrong response');
  if ('error' in res) throw new ApiError(res.error.code, res.error.message);
}

export async function setCaching(value: number) {
  const [sn, s] = getSession();
  const res = await sendRequest(
    `${Constants.apiBaseUrl}/settings_set?${sn}=${s}&var=http_caching&` +
      `val=${value}`,
    { ...Device.getDeviceHeaders() },
  );
  if (!(res instanceof Object)) throw new ApiError(-2, 'Wrong response');
  if ('error' in res) throw new ApiError(res.error.code, res.error.message);
}

export async function logout(): Promise<void> {
  const [sn, s] = getSession();
  const res = await sendRequest(`${Constants.apiBaseUrl}/logout?${sn}=${s}`, {
    ...Device.getDeviceHeaders(),
  });
  if (!(res instanceof Object)) throw new ApiError(-2, 'Wrong response');
  if ('error' in res) throw new ApiError(res.error.code, res.error.message);
}

export async function getUid(deviceId: string): Promise<string> {
  const res = await sendRequest(
    `${Constants.apiBaseUrlV3}/get-uid?id_device=${deviceId}`,
    { ...Device.getDeviceHeaders() },
  );
  if (!(res instanceof Object)) throw new ApiError(-2, 'Wrong response');
  if ('code' in res) throw new ApiError(res.code, res.error.message);
  return res.uid;
}

export async function heartbeat(
  uid: string,
): Promise<{ attempt: number; status: string }> {
  const res = await sendRequest(
    `${Constants.apiBaseUrlV3}/qr-heartbeat?uid=${uid}`,
    { ...Device.getDeviceHeaders() },
  );
  return res;
}

export async function checkNetwork(): Promise<void> {
  await fetch('https://iptvn.idc.md/api');
}

export async function changeParentPass(pass: string, newPass: string) {
  const data = new FormData();
  data.append('old_code', pass);
  data.append('new_code', newPass);
  data.append('confirm_code', newPass);

  const [sn, s] = getSession();
  const res = await sendRequest(
    `${Constants.apiBaseUrl}/settings_set?${sn}=${s}&var=pcode`,
    { ...Device.getDeviceHeaders() },
    data,
  );
  if (!(res instanceof Object)) throw new ApiError(-2, 'Wrong response');
  if ('error' in res) throw new ApiError(res.error.code, res.error.message);
}

export async function faq(): Promise<FaqItemType[]> {
  const res = await sendRequest(`${Constants.apiBaseUrlV3}/info/faq`, {
    ...Device.getDeviceHeaders(),
  });
  return res.accordion;
}
